import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { StoreProvider } from "@/context/StoreContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
const Faq = lazy(() => import("@/pages/Faq"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const Policy = lazy(() => import("@/pages/Policy"));
const PaymentSuccess = lazy(() => import("@/pages/Payment").then((m) => ({ default: m.PaymentSuccess })));
const PaymentCancel = lazy(() => import("@/pages/Payment").then((m) => ({ default: m.PaymentCancel })));
const Admin = lazy(() => import("@/pages/Admin"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Account = lazy(() => import("@/pages/Account"));
const Subscribe = lazy(() => import("@/pages/Subscribe"));
import NotFound from "@/pages/NotFound";
const Quest = lazy(() => import("@/pages/Quest"));
const Quiz = lazy(() => import("@/pages/Quiz"));
const CaptainsClub = lazy(() => import("@/pages/CaptainsClub"));
import { useEffect, lazy } from "react";
import { useStore } from "@/context/StoreContext";

const CartRoute = () => {
  const { setCartOpen } = useStore();
  useEffect(() => { setCartOpen(true); }, [setCartOpen]);
  return <Navigate to="/shop" replace />;
};

const AuthShell = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

const AuthPage = ({ children }) => (
  <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">{children}</div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:id" element={<ProductPage />} />
              <Route path="/tips" element={<Navigate to="/blog" replace />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop/bone-and-heart" element={<Navigate to="/shop/bone-k2" replace />} />
              <Route path="/shop/bundle" element={<Navigate to="/shop" replace />} />
              <Route path="/shop/ocean-greens" element={<Navigate to="/shop/ocean-basics" replace />} />
              <Route path="/bundle" element={<Navigate to="/shop" replace />} />
              <Route path="/shop/daily-stack" element={<Navigate to="/shop" replace />} />
              <Route path="/products/:id" element={<Navigate to="/shop" replace />} />
              <Route path="/waitlist" element={<Navigate to="/" replace />} />
              <Route path="/policies/privacy" element={<Navigate to="/privacy" replace />} />
              <Route path="/policies/refunds" element={<Navigate to="/refund-policy" replace />} />
              <Route path="/returns" element={<Navigate to="/refund-policy" replace />} />
              <Route path="/refund-policy" element={<Policy fixedSlug="refunds" />} />
              <Route path="/policies/:slug" element={<Policy />} />
              <Route path="/privacy" element={<Policy fixedSlug="privacy" />} />
              <Route path="/quest" element={<Quest />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/order/confirmed" element={<PaymentSuccess />} />
              <Route path="/cart" element={<CartRoute />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route element={<AuthShell />}>
                <Route path="/admin" element={<Admin />} />
                <Route path="/account" element={<Account />} />
                <Route path="/subscribe/:id" element={<Subscribe />} />
                <Route path="/captains-club" element={<CaptainsClub />} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/account" /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/account" /></AuthPage>} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
